document.addEventListener("DOMContentLoaded", function() {
    var scrollHeight = sessionStorage.getItem("selectedItemId");
    let OptionValue = sessionStorage.getItem("selectedOption");
   
         if (scrollHeight) {
          
           console.log('test',OptionValue);
           //console.log(scrollHeight);
              $('html, body').animate({
                 scrollTop: scrollHeight
             }, 1000);
          // $('html, body').scrollTop(scrollHeight);
             
             sessionStorage.removeItem("selectedItemId");
            
         }
 
   
     setTimeout(function() {
        
 
         var customSelectorContainer = document.querySelector('.custom-home-selector');
         var selectorRoot = customSelectorContainer.querySelector('selector-root');
         if (selectorRoot) {
             var shadowRoot = selectorRoot.shadowRoot;
             if (shadowRoot) {
                 var items = shadowRoot.querySelectorAll(".sel-item");
                 items.forEach(function(item) {
                       item.addEventListener("click", function(event) {
                      //   var currentScrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0; 
                        var currentScrollHeight = $(window).scrollTop();
                         sessionStorage.setItem("selectedItemId", currentScrollHeight);
                     });
                 });
            }
         }
     }, 200);
 });